import { AxiosResponse } from "axios";
import { api } from "../base/api";
import {
	UserGroupFilterRequest,
	UserGroupRegisterRequest,
	UsergroupSaveControlsRequest,
	UsergroupSaveRequest,
} from "../../models/request";
import { IUsergroupApi } from "../base/registration/usergroupApi";
import { Result } from "../../models/common/resultResponse";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { GroupResponse } from "@/main/models/response/usergroupResponse";

const baseRoute: string = "Group";

export class UsergroupApi extends IUsergroupApi {
	getSearchGrid(request: UserGroupFilterRequest): Promise<AxiosResponse<PaginationResponse<GroupResponse>>> {
		return api.get(`${baseRoute}`, { params: request });
	}

	changeStatusUserGroup(request: UserGroupFilterRequest): Promise<AxiosResponse<Result<void>>> {
		return api.post(`${baseRoute}/setActiveValue`, request);
	}

	getRegistrationDataUsergroup(
		request: UserGroupRegisterRequest,
	): Promise<AxiosResponse<Result<UsergroupRegistrationDataResponse>>> {
		return api.get(`${baseRoute}/${request.guidUsergroup}`, {
			params: {
				idSystemApplication: request.idSystemApplication,
			},
		});
	}

	saveUsergroup(request: UsergroupSaveRequest): Promise<AxiosResponse<Result<void>>> {
		return api.post(`${baseRoute}/save`, request);
	}

	saveSaveControlsUsergroup(request: UsergroupSaveControlsRequest): Promise<AxiosResponse<Result<void>>> {
		return api.post(`${baseRoute}/${request.guidUsergroup}/SaveControls`, request.controls);
	}
}
